import React from 'react';
import { Container, Typography, Box, Avatar, Grid, Paper, Button } from '@mui/material';
import './ProfilePage.css';

const ProfilePage = () => {
  return (
    <Container className="profile-container">
      <Box my={4}>
        <Typography variant="h4" gutterBottom className="profile-title">
          Perfil de Usuario
        </Typography>
        <Paper className="profile-paper">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4} className="profile-avatar-container">
              <Avatar alt="User Avatar" src="/static/images/avatar/1.jpg" className="profile-avatar" />
            </Grid>
            <Grid item xs={12} sm={8}>
              <Typography variant="h6" gutterBottom>
                Nombre: Juan Pérez
              </Typography>
              <Typography variant="body1" gutterBottom>
                Email: juan.perez@example.com
              </Typography>
              <Typography variant="body1" gutterBottom>
                Teléfono: 555-555-5555
              </Typography>
              <Typography variant="body1" gutterBottom>
                Dirección: Calle Falsa 123, Ciudad, País
              </Typography>
              <Box mt={2}>
                <Button variant="contained" color="primary">
                  Editar Perfil
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
};

export default ProfilePage;